import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import Badge from '@anm/components/Badge';
import Button from '@anm/components/buttons/Button';
import getPeriodName from '@anm/helpers/subscription/getPeriodName';
import { useCallback, FC } from 'react';

import { SwitchPeriodWrapper } from './Wrapper';

export type SwitchPeriodProps = {
  toPeriod: SubscriptionPeriod;
  onSwitch: (toPeriod: SubscriptionPeriod) => void;
  save?: number;
};

const SwitchPeriod: FC<SwitchPeriodProps> = ({ save, toPeriod, onSwitch }) => {
  const handleSwitch = useCallback(() => onSwitch(toPeriod), [toPeriod]);

  return (
    <SwitchPeriodWrapper>
      {save && <Badge variant="yellow">SAVE ${save}</Badge>}
      <Button variant="link" size="medium" onClick={handleSwitch}>
        Switch to {getPeriodName(toPeriod)}
      </Button>
    </SwitchPeriodWrapper>
  );
};

export default SwitchPeriod;
